import React from 'react'
import { withTranslation } from 'react-i18next'
import { useQuery, gql } from '@apollo/client'
import { Grid } from '@mui/material'
import Header from '../components/Headers/Header'
import { getConfiguration } from '../apollo'
import LoyaltyConfiguration from '../components/Configuration/Loyalty/Loyalty'

const GET_CONFIGURATION = gql`
  ${getConfiguration}
`

const Loyalty = props => {
  const { t } = props
  const { data, error: errorQuery, loading: loadingQuery } = useQuery(
    GET_CONFIGURATION
  )

  return (
    <>
      <Header />
      {errorQuery && t('Error')}
      {loadingQuery ? (
        t('LoadingDots')
      ) : (
        <Grid container ml={2} spacing={2}>
          <Grid item xs={12} md={12} lg={6}>
            <LoyaltyConfiguration
              loyaltyEnabled={data && data.configuration.loyaltyEnabled}
              loyaltyTiers={data && data.configuration.loyaltyTiers}
              creditsPerPound={data && data.configuration.creditsPerPound}
            />
          </Grid>
        </Grid>
      )}
    </>
  )
}

export default withTranslation()(Loyalty)
